import * as React from 'react';
export var MenuContext = React.createContext({});
export var useMenuContext = function () {
    return React.useContext(MenuContext);
};
//# sourceMappingURL=MenuContext.js.map